// #ux-redesign-start: helpLogin rediseñada (Paso 5 — Patients)
// Misma estructura visual que PasswordRecovery — pide email y dispara
// actionSendHelp con `type: 'patient'`. Reusa AuthLayout + AuthCard del DS.
// ─────────────────────────────────────────────────────────────────────────────

import React, { Fragment, useState } from "react";
import { useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import { useTranslate } from "react-translate";
import { useForm } from "react-hook-form";
import * as yup from "yup";

import { actionSendHelp } from "store/actions/usersActions";

import AuthLayout from "components/Auth/AuthLayout";
import AuthCard from "components/Auth/AuthCard";
import { Button, Input } from "components/ds";

const MailIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
    <polyline points="22,6 12,13 2,6" />
  </svg>
);

const HelpLogin = () => {
  const t = useTranslate("help-login");
  const tLogin = useTranslate("login-page");
  const dispatch = useDispatch();
  const [submitting, setSubmitting] = useState(false);

  const schema = yup.object().shape({
    email: yup.string().email(t("email-placeholder") + "...").required(t("email-placeholder") + "..."),
  });

  const { register, handleSubmit, errors } = useForm({
    validationSchema: schema,
    mode: "onChange",
  });

  const onSubmit = async ({ email }) => {
    setSubmitting(true);
    await dispatch(
      actionSendHelp({
        email: email.trim().toLowerCase(),
        type: "patient",
      })
    );
    setTimeout(() => setSubmitting(false), 2000);
  };

  const footerLinks = (
    <Link to="/auth/login-page" name="link_back_login">
      {t("back")}
    </Link>
  );

  return (
    <Fragment>
      <AuthLayout
        panelTitle={tLogin("login") || t("title")}
        panelSubtitle={t("description")}
      >
        <AuthCard title={t("title")} description={t("description")} footerLinks={footerLinks}>
          <form className="ds-auth__form" onSubmit={handleSubmit(onSubmit)} noValidate>
            <Input
              name="email"
              type="email"
              autoComplete="email"
              label={t("email-placeholder")}
              placeholder={t("email-placeholder") + "..."}
              iconLeft={<MailIcon />}
              innerRef={register}
              error={errors.email?.message}
            />
            <div className="ds-auth__card-actions">
              <Button
                type="submit"
                variant="primary"
                size="lg"
                fullWidth
                loading={submitting}
                name="button_help"
              >
                {t("send-btn")}
              </Button>
            </div>
          </form>
        </AuthCard>
      </AuthLayout>
    </Fragment>
  );
};

export default HelpLogin;
// #ux-redesign-end
